(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const checkArrowes = document.getElementsByClassName("Collapsed_Title");
    for (const Collapsible__Arrow of checkArrowes) {
      Collapsible__Arrow.addEventListener(
        "click",
        function () {
          var arrow = this.getElementsByClassName("arrow")[0];
          if (!this.classList.contains("is-flipped")) {
            this.classList.add("is-flipped");
            this.getElementsByClassName("arrow")[0].classList.remove("up");
            this.getElementsByClassName("arrow")[0].classList.add("down");
            this.lastElementChild.style.display = "grid";
          } else {
            this.classList.remove("is-flipped");
            this.getElementsByClassName("arrow")[0].classList.remove("down");
            this.getElementsByClassName("arrow")[0].classList.add("up");
            this.lastElementChild.style.display = "none";
          }
        },
        false
      );
    }
  });
})();
/**  // Function for POPUP in the announcement bar 
(function () {
  const modal = document.querySelector(".cust_modal");
  const overlay = document.querySelector(".cust_overlay");
  const openModalBtn = document.querySelector(".cust_btn-open");
  const closeModalBtn = document.querySelector(".cust_btn-close");
  const headerSticky = document.getElementsByClassName(
    "shopify-section shopify-section-group-header-group shopify-section--header"
  )[0];
  // close modal function
  const closeModal = function () {
    modal.classList.add("hidden");
    overlay.classList.add("hidden");
    headerSticky.classList.remove("no_z-index");
  };

  // close the modal when the close button and overlay is clicked
  closeModalBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  // close modal when the Esc key is pressed
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });

  // open modal function
  const openModal = function () {
    modal.classList.remove("hidden");
    overlay.classList.remove("hidden");
    headerSticky.classList.add("no_z-index");
  };
  // open modal event
  if (openModalBtn) {
      openModalBtn.addEventListener("click", openModal);
  }
})();
**/
(function () {
  if (window.location.pathname.indexOf("/products/") !== -1) {
    var start_variant = document.getElementsByClassName(
      "ProductItem__Variant Variant-selected"
    )[0];
    var start_variant_id = start_variant.id;
    var box_variant_selected = document.getElementById(start_variant_id);
    var variant_lastChild = box_variant_selected.lastElementChild; // Get the last child element
    var final_sale_check = variant_lastChild.getAttribute("final-sale");
    // CUSTOM FINAL SALE
    var final_sale_input = document.getElementById("attribute-final-sale");
    final_sale_input.setAttribute("value", final_sale_check);

    // custom photo switcher show/hidden
    var product_photos = document.querySelectorAll(
      "div.product-gallery__media"
    );
    var selected_option_size = box_variant_selected.getAttribute(
      "variant-option-size"
    );
    var selected_option_color = box_variant_selected.getAttribute(
      "variant-option-color"
    );
    var selected_option_type = box_variant_selected.getAttribute(
      "variant-option-type"
    );

    product_photos.forEach((div) => {
      var media_option_size = div.getAttribute("media-option-size");
      var media_option_color = div.getAttribute("media-option-color");
      var media_option_type = div.getAttribute("media-option-type");
      if (
        (media_option_size == selected_option_size || !media_option_size) &&
        (media_option_color == selected_option_color || !media_option_color) &&
        (media_option_type == selected_option_type || !media_option_type)
      ) {
        //do something
        div.removeAttribute("hidden");
      } else {
        //do something
        div.setAttribute("hidden", "");
      }
    });

    document.addEventListener("variant:change", function (event) {
      let variant = event.detail.variant; // Gives you access to the whole variant details
      let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
      let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
      let form = event.target; // The form that triggers the change
      var variant_id = variant.id;
      var box_variant_selected = document.getElementById(variant_id);
      var variant_lastChild = box_variant_selected.lastElementChild; // Get the last child element
      var final_sale_check = variant_lastChild.getAttribute("final-sale");
      console.log(variant_id + " check final sale:" + final_sale_check);
      // custom photo switcher show/hidden
      var product_photos = document.querySelectorAll(
        "div.product-gallery__media"
      );
      var selected_option_size = box_variant_selected.getAttribute(
        "variant-option-size"
      );
      var selected_option_color = box_variant_selected.getAttribute(
        "variant-option-color"
      );
      var selected_option_type = box_variant_selected.getAttribute(
        "variant-option-type"
      );

      product_photos.forEach((div) => {
        var media_option_size = div.getAttribute("media-option-size");
        var media_option_color = div.getAttribute("media-option-color");
        var media_option_type = div.getAttribute("media-option-type");
        if (
          (media_option_size == selected_option_size || !media_option_size) &&
          (media_option_color == selected_option_color ||
            !media_option_color) &&
          (media_option_type == selected_option_type || !media_option_type)
        ) {
          //do something
          div.removeAttribute("hidden");
        } else {
          //do something
          div.setAttribute("hidden", "");
        }
      });
      // CUSTOM FINAL SALE
      var final_sale_input = document.getElementById("attribute-final-sale");
      final_sale_input.setAttribute("value", final_sale_check);
      console.log(final_sale_input);
      // CUSTOM VARIANT SALE
      var box_product = box_variant_selected.parentElement;
      console.log(box_product);
      box_product.querySelectorAll("div.Variant-selected").forEach((div) => {
        div.classList.remove("Variant-selected");
        div.style.display = "none";
      });
      box_variant_selected.removeAttribute("style");
      box_variant_selected.classList.add("Variant-selected");
      return;
    });
  } else {
    document.addEventListener("change", function (event) {
      let selected_swatch = event.target.value;
      let product_card = event.target.offsetParent;
      let box_product = product_card.lastElementChild;
      var box_variant_selected = "";

      box_product.querySelectorAll("div.Variant-selected").forEach((div) => {
        div.classList.remove("Variant-selected");
        div.style.display = "none";
      });
      var targeted_el = box_product.querySelectorAll(
        'div[variant-option-color="' + selected_swatch + '"]'
      )[0];
      targeted_el.removeAttribute("style");
      targeted_el.classList.add("Variant-selected");
    });
  }
})();

// DEACTIVATED THE VARIANT SCROLL on product page from "theme.js" row 3400

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.indexOf("/products/") !== -1) {
      var carousel = document.querySelector(".product-gallery__carousel");
      if (carousel.isScrollable) {
        carousel.select(0, { instant: true });
      }
      document.addEventListener("cart:refresh", function (event) {
        const cartDrawer = document.querySelector("cart-drawer");
        setTimeout(function () {
          cartDrawer.show();
        }, 1000);
      });
    }
  });
})();

document.addEventListener('DOMContentLoaded', () => {
    /**
     * Universal Focus Trap logic for modals/popups
     */
    window.trapFocus = function(element) {
        // Select all focusable elements within the modal
        const focusableElements = element.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        element.addEventListener('keydown', function (e) {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return; // If it's not the TAB key, do nothing
            }

            if (e.shiftKey) {
                // If Shift + Tab
                if (document.activeElement === firstElement) {
                    lastElement.focus(); // Jump to the last element
                    e.preventDefault();
                }
            } else {
                // If just Tab
                if (document.activeElement === lastElement) {
                    firstElement.focus(); // Jump back to the first element
                    e.preventDefault();
                }
            }
        });
    }

    // --- Apply to the Newsletter Popup ---

    const newsletterPopup = document.querySelector('newsletter-popup');

    if (newsletterPopup) {
        // 1. Trap the focus inside the modal so it can't escape
        trapFocus(newsletterPopup);

        // 2. Set up an observer to automatically set focus to the first element when it opens
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    if (newsletterPopup.hasAttribute('open')) {
                        // A short timeout ensures the browser renders the display change before focusing
                        setTimeout(() => {
                            const focusableElements = newsletterPopup.querySelectorAll(
                                'button:not([disabled]), input:not([disabled])'
                            );
                            if (focusableElements.length > 0) {
                                // Try to focus the close button or first input when it opens
                                focusableElements[0].focus();
                            }
                        }, 100);
                    }
                }
            });
        });

        observer.observe(newsletterPopup, {
            attributes: true // We listen for when the 'open' attribute is added/removed
        });
    }
});

//empty heading
(function () {
  function removeEmptyHeadings() {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach(function (heading) {
      const text = heading.textContent.replace(/\u00A0/g, ' ').trim(); // strips &nbsp; too
      const hasImage = heading.querySelector('img, svg');
      const hasIcon  = heading.querySelector('[class*="icon"], [class*="fa-"], [aria-hidden]');

      if (!text && !hasImage && !hasIcon) {
        heading.remove();
      }
    });
  }

  // ── 1. Run on initial DOM ready ──────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyHeadings);
  } else {
    removeEmptyHeadings();
  }

  // ── 2. Re-run after full page load (catches late-injected content) ──
  window.addEventListener('load', removeEmptyHeadings);

  // ── 3. Watch for 3rd-party / dynamic content added after load ──
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) removeEmptyHeadings();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//h1
(function () {
  function addHiddenH1FromTitle() {
    // ── 1. Check if page already has an h1 ──────────────────────
    const existingH1 = document.querySelector('h1');
    if (existingH1) return; // h1 exists — do nothing

    // ── 2. Get text from <title>, strip site name after separator ─
    const rawTitle = document.title || '';
    const pageTitle = rawTitle
      .split(/[|\-–—]/)  // split on | - – —
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; })[0] || rawTitle.trim();

    if (!pageTitle) return; // no title text found — bail

    // ── 3. Create visually hidden h1 ────────────────────────────
    const h1 = document.createElement('h1');
    h1.textContent = pageTitle;

    // Visually hidden but fully accessible to screen readers
    h1.style.cssText = [
      'position: absolute',
      'width: 1px',
      'height: 1px',
      'padding: 0',
      'margin: -1px',
      'overflow: hidden',
      'clip: rect(0, 0, 0, 0)',
      'white-space: nowrap',
      'border: 0'
    ].join('; ');

    // ── 4. Inject as first element inside <main> or <body> ───────
    const target = document.querySelector('main') ||
                   document.querySelector('[role="main"]') ||
                   document.body;

    target.insertBefore(h1, target.firstChild);
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHiddenH1FromTitle);
  } else {
    addHiddenH1FromTitle();
  }

})();

//product alt
/**
 * product-gallery-alt-fix.js
 *
 * Fixes product gallery image alt text at runtime without touching any
 * backend Liquid files:
 *  • Strips raw Shopify variant encoding from alt tags
 *    e.g.  "Mirage//"  →  "Mirage"
 *  • Adds per-color sequential image numbers
 *    e.g.  "Mirage - Image 1",  "Mirage - Image 2",  "Spice - Image 1"
 *  • Keeps the wrapper div aria-label in sync so screen readers get
 *    the same meaningful text
 *  • Re-runs automatically whenever a color / variant switch updates
 *    the gallery (watches for DOM changes with MutationObserver)
 *
 * ─── HOW TO INSTALL ──────────────────────────────────────────────────────────
 *
 *  Option A — Shopify theme asset (recommended)
 *  1. Upload this file to your theme's  assets/  folder.
 *  2. Add one line before </body> in  layout/theme.liquid :
 *
 *       <script src="{{ 'product-gallery-alt-fix.js' | asset_url }}" defer></script>
 *
 *  Option B — Paste inline into theme.liquid
 *  Wrap the contents in <script> … </script> and place before </body>.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  // ── Helpers ─────────────────────────────────────────────────────────────────

  /**
   * Extracts the human-readable color name from a raw Shopify media alt string.
   * Shopify stores variant metadata in the format  "Color/Type/Size"
   * so splitting on "/" and taking index 0 gives us just the color.
   *
   * "Mirage//"     → "Mirage"
   * "Spice//"      → "Spice"
   * "Rose Dawn//"  → "Rose Dawn"
   * ""             → ""
   */
  function extractColor(rawAlt) {
    return (rawAlt || '').split('/')[0].trim();
  }

  /**
   * Builds and applies clean alt text to every media item inside a single
   * <product-gallery> element.
   *
   * Counting strategy:
   *   - One counter per color key (case-insensitive).
   *   - Counts ALL items in DOM order regardless of hidden state, so numbers
   *     stay stable across variant switches.
   */
  function fixGallery(gallery) {
    var mediaItems = gallery.querySelectorAll('.product-gallery__media');
    if (!mediaItems.length) return;

    var colorCounts = {};

    mediaItems.forEach(function (item) {

      // ── 1. Resolve the color label ──────────────────────────────────────────
      // First try the explicit attribute the theme puts on the wrapper div,
      // then fall back to parsing the raw img alt, then to product title.

      var color = (item.getAttribute('media-option-color') || '').trim();

      if (!color) {
        var img = item.querySelector('img');
        if (img) color = extractColor(img.getAttribute('alt'));
      }

      if (!color) {
        var titleEl =
          document.querySelector('.product__title') ||
          document.querySelector('h1.title')        ||
          document.querySelector('[class*="product-title"]');
        color = titleEl ? titleEl.textContent.trim() : 'Product';
      }

      // ── 2. Increment the per-color counter ──────────────────────────────────
      var key = color.toLowerCase();
      colorCounts[key] = (colorCounts[key] || 0) + 1;

      var altText = color + ' - Image ' + colorCounts[key];

      // ── 3. Write the clean alt / aria text to every relevant element ────────

      // <img> alt  (most important — fixes what the screen reader reads)
      var imgEl = item.querySelector('img');
      if (imgEl) imgEl.setAttribute('alt', altText);

      // <video>  (for video media type items)
      var videoEl = item.querySelector('video');
      if (videoEl) {
        videoEl.setAttribute('aria-label', altText);
        videoEl.setAttribute('title', altText);
      }

      // Wrapper div aria-label  — screen readers announce this for role="group"
      item.setAttribute('aria-label', altText);
    });

    // ── Thumbnail strip (product-page layout) ──────────────────────────────────
    // Thumbnail <img> tags have the same "Color//" problem; fix them too.
    var thumbCounts = {};
    gallery.querySelectorAll('.product-gallery__thumbnail img').forEach(function (thumb) {
      var color = extractColor(thumb.getAttribute('alt')) || 'Product';
      var key   = color.toLowerCase();
      thumbCounts[key] = (thumbCounts[key] || 0) + 1;
      thumb.setAttribute('alt', color + ' - Image ' + thumbCounts[key]);
    });
  }

  function fixAllGalleries() {
    document.querySelectorAll('product-gallery').forEach(fixGallery);
  }

  // ── Debounce ─────────────────────────────────────────────────────────────────
  // Variant switches can trigger many DOM mutations at once; debouncing ensures
  // fixAllGalleries runs once after the burst settles.
  var debounceTimer;
  function scheduleFix() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fixAllGalleries, 60);
  }

  // ── Initial run ──────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAllGalleries);
  } else {
    fixAllGalleries();
  }

  // ── MutationObserver — re-run on variant / color switch ──────────────────────
  // The Impact theme toggles the `hidden` attribute on .product-gallery__media
  // items when the user picks a different color; we watch for that.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].target.closest('product-gallery')) {
        scheduleFix();
        return; // one scheduled call is enough
      }
    }
  });

  function attachObserver() {
    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      observer.observe(gallery, {
        attributes : true,
        attributeFilter : ['hidden'],  // only care about visibility toggles
        subtree    : true,
        childList  : true,             // catch dynamically injected items too
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

})();
//variant
/**
 * Accessibility patch for the variant picker (color/size swatches).
 * Fixes two issues without touching variant-picker.liquid or swatch.liquid:
 *
 * 1. Group context — each option's <legend> sits inside extra wrapper <div>s
 *    instead of being a direct child of its <fieldset>, so the native
 *    fieldset/legend pairing breaks and "Color" / "Size" never gets
 *    announced before the option values. This re-links them explicitly with
 *    aria-labelledby, which works by id reference and doesn't care about
 *    DOM nesting depth.
 *
 * 2. Sold-out variants — the theme's own JS toggles an `is-disabled` class
 *    on a swatch <label> as the customer changes selections, but never
 *    touches the underlying <input>, so screen readers have no signal that
 *    an option just became unavailable. A MutationObserver mirrors that
 *    class onto aria-disabled (plus a hidden text hint) every time it
 *    changes, since the disabled state is set dynamically based on the
 *    current selection, not just once on page load.
 */
(() => {
  // Set to true if sold-out variants should also become unselectable
  // (native `disabled` removes them from focus/click entirely). Leave
  // false to keep the current behavior of letting shoppers click through
  // to a sold-out combination.
  const PREVENT_SELECTION_OF_SOLD_OUT = false;

  const uniqueId = (prefix) => `${prefix}-${Math.random().toString(36).slice(2, 9)}`;

  const labelGroup = (fieldset) => {
    if (fieldset.hasAttribute('aria-labelledby')) return;
    const legend = fieldset.querySelector('legend');
    if (!legend) return;
    if (!legend.id) legend.id = uniqueId('variant-option-legend');
    fieldset.setAttribute('aria-labelledby', legend.id);
  };

  // Reads an optional data-sold-out-label="{{ 'product.general.sold_out_badge' | t }}"
  // attribute on the nearest <variant-picker> for translated text. Falls back to
  // plain English if that attribute isn't added.
  const soldOutLabelFor = (swatchLabel) => {
    const picker = swatchLabel.closest('variant-picker');
    return (picker && picker.dataset.soldOutLabel) || 'Sold out';
  };

  const syncSwatch = (swatchLabel) => {
    const input = swatchLabel.control;
    if (!input) return;

    const isUnavailable = swatchLabel.classList.contains('is-disabled');
    let hint = swatchLabel.querySelector('[data-a11y-sold-out-hint]');

    if (isUnavailable) {
      input.setAttribute('aria-disabled', 'true');
      if (PREVENT_SELECTION_OF_SOLD_OUT) input.disabled = true;

      if (!hint) {
        hint = document.createElement('span');
        hint.setAttribute('data-a11y-sold-out-hint', '');
        hint.className = 'sr-only';
        swatchLabel.appendChild(hint);
      }
      hint.textContent = ` (${soldOutLabelFor(swatchLabel)})`;
    } else {
      input.removeAttribute('aria-disabled');
      if (PREVENT_SELECTION_OF_SOLD_OUT) input.disabled = false;
      if (hint) hint.remove();
    }
  };

  const scan = (root) => {
    root.querySelectorAll('.variant-picker__option').forEach(labelGroup);
    root.querySelectorAll('[data-option-value]').forEach(syncSwatch);
  };

  scan(document);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        if (target.matches && target.matches('[data-option-value]')) {
          syncSwatch(target);
        }
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('.variant-picker__option')) labelGroup(node);
        if (node.matches('[data-option-value]')) syncSwatch(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
})();
//media pause button
/**
 * VIDEO PAUSE / PLAY — ACCESSIBILITY BUTTON
 * ==========================================
 * Wires up every .video-play-pause-btn to the <video> element
 * inside its parent <video-media> custom element.
 *
 * Where to add this file:
 *   Option A — Paste the contents into assets/theme.js (at the end).
 *   Option B — Save as assets/video-play-pause.js, then include it in
 *              your layout/theme.liquid BEFORE </body>:
 *              <script src="{{ 'video-play-pause.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ── Bootstrap ──────────────────────────────────────────────────────────── */

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', initAll);

  // Re-run when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', initAll);

  /* ── Core logic ─────────────────────────────────────────────────────────── */

  function initAll() {
    document.querySelectorAll('.video-play-pause-btn').forEach(initButton);
  }

  /**
   * Attaches click + state-sync listeners to a single pause/play button.
   * A data attribute guards against double-initialisation.
   *
   * @param {HTMLButtonElement} btn
   */
  function initButton(btn) {
    if (btn.dataset.vpInitialized) return;
    btn.dataset.vpInitialized = 'true';

    const videoMedia = btn.closest('video-media');
    if (!videoMedia) return;

    // The <video> element may not exist yet if the browser hasn't loaded it.
    // Use a helper that retries until it appears (handles lazy-loaded sections).
    waitForVideo(videoMedia, function (video) {
      // ── Click: toggle playback ────────────────────────────────────────
      // stopPropagation + preventDefault prevent the click from bubbling
      // up to any parent <a> tag that wraps the video (e.g. a linked banner).
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      // ── Sync button UI to actual video state ──────────────────────────
      video.addEventListener('pause', function () {
        setButtonState(btn, 'paused');
      });

      video.addEventListener('play', function () {
        setButtonState(btn, 'playing');
      });

      // Set initial state in case the video hasn't started yet
      setButtonState(btn, video.paused ? 'paused' : 'playing');
    });
  }

  /**
   * Updates the button's aria-label, aria-pressed, and CSS class
   * to reflect the current playback state.
   *
   * @param {HTMLButtonElement} btn
   * @param {'playing'|'paused'} state
   */
  function setButtonState(btn, state) {
    if (state === 'paused') {
      btn.setAttribute('aria-label', 'Play video');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('title', 'Play video');
      btn.classList.add('is-paused');
    } else {
      btn.setAttribute('aria-label', 'Pause video');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('title', 'Pause video');
      btn.classList.remove('is-paused');
    }
  }

  /**
   * Polls for a <video> element inside `container`.
   * Resolves as soon as one appears, or times out after ~3 seconds.
   *
   * @param {Element}  container
   * @param {Function} callback   Called with the <video> element
   */
  function waitForVideo(container, callback) {
    var video = container.querySelector('video');
    if (video) {
      callback(video);
      return;
    }

    // Retry using a MutationObserver (handles async rendering)
    var attempts = 0;
    var maxAttempts = 30; // 30 × 100 ms = 3 s

    var interval = setInterval(function () {
      video = container.querySelector('video');
      attempts++;

      if (video) {
        clearInterval(interval);
        callback(video);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn(
          '[video-play-pause] Could not find <video> inside',
          container
        );
      }
    }, 100);
  }
})();